export default "__VITE_ASSET__92f1cb1d__"